export default __webpack_public_path__ + "static/media/Middle-Banner.f168f519.jpg";